import ValuationMethodWarningDialog from './ValuationMethodWarningDialog';

export default ValuationMethodWarningDialog;
